import * as R from 'ramda'

export function create_default_addresses_patch(id, addressId) {
    return R.compose(

        // ID setzen
        // > { defaultCorrespondenceAddress: 13, defaultShippingAddress: 13 }
        // < { id: 1, defaultCorrespondenceAddress: 13, defaultShippingAddress: 13 }
        R.assoc('id', id ),

        // Objekt mit `addressId` erstellen
        // > [ 'defaultCorrespondenceAddress', 'defaultShippingAddress' ]
        // < { defaultCorrespondenceAddress: 13, defaultShippingAddress: 13 }
        R.reduce((obj, key) => R.assoc(key, addressId, obj), {}),

        // Properties lesen
        // > [ [ 'defaultCorrespondenceAddress', true ], [ 'defaultShippingAddress', true ] ]
        // < [ 'defaultCorrespondenceAddress', 'defaultShippingAddress' ]
        R.map(R.head),

        // Nach Standardadressen filtern, die `true` sind
        // > [ [ 'defaultBillingAddress', false ], [ 'defaultCorrespondenceAddress', true ], [ 'defaultShippingAddress', true ] ]
        // < [ [ 'defaultCorrespondenceAddress', true ], [ 'defaultShippingAddress', true ] ]
        R.filter(R.nth(1)),

        // Objekt in Paare splitten
        // > { defaultBillingAddress: false, defaultCorrespondenceAddress: true, defaultShippingAddress: true }
        // < [ [ 'defaultBillingAddress', false ], [ 'defaultCorrespondenceAddress', true ], [ 'defaultShippingAddress', true ] ]
        R.toPairs,

        // Properties bzgl. Standardadressen laden
        // > { id: 1, defaultBillingAddress: false, defaultCorrespondenceAddress: true, defaultShippingAddress: true }
        // < { defaultBillingAddress: false, defaultCorrespondenceAddress: true, defaultShippingAddress: true }
        R.pick(['defaultBillingAddress', 'defaultCorrespondenceAddress', 'defaultShippingAddress'])

    )
}

export function find_by_default_shipping_address(models, addressId) {
    return R.find(model => model.defaultShippingAddress === addressId, models)
}

export function filter_by_type(type, models) {
    const filter_by              = property => R.filter(R.propEq(property, true), models)
    const filter_by_is_agency    = () => filter_by('isAgency')
    const filter_by_is_purchaser = () => filter_by('isPurchaser')
    const filter_by_is_supplier  = () => filter_by('isSupplier')

    return R.compose(

        R.cond([

            [R.equals('AGENCY'),    filter_by_is_agency],
            [R.equals('SUPPLIER'),  filter_by_is_supplier],
            [R.equals('PURCHASER'), filter_by_is_purchaser],
            [R.T,                   R.always(models)]

        ]),

        // > supplier
        // > SUPPLIER
        R.toUpper,

        // > supplier
        // < supplier
        R.defaultTo('')

    )(type)
}




